import cn from 'classnames';


import styles from './VideoCover.module.scss';

import { AuthorIntro } from '@components/Article';
import { getArticleUrl } from '@lib/article/getters';
import { getArticleImgUrl } from '@lib/image/getters';
import { Link } from '@lib/navigation';
import PlaySVG from 'public/static/svg/play.svg';
import { ArticleI } from 'types/article';


type PropTypes = {
  article: ArticleI;
  variant: 'header' | 'main';
};
function VideoCover({ article, variant }: PropTypes) {
  const { author, dateGmt, title } = article;

  const videoBlockClassName = cn(styles.videoBlock, styles[variant]);

  const articleUrl = getArticleUrl(article);

  const articleImg = getArticleImgUrl(article, 'large');

  return (
    <div
      className={videoBlockClassName}
      style={{ backgroundImage: `url(${articleImg})` }}
    >
      <div className={styles.overlay}></div>
      {/* eslint-disable-next-line @next/next/no-img-element*/}
      <img
        className={styles.img}
        src={articleImg}
        alt={title}
      />
      <Link
        href={articleUrl}
        style={{ position: 'absolute', inset: '0' }}
      ></Link>
      <div className={styles.footer}>
        <Link href={articleUrl} className={styles.play}>
          <PlaySVG />
        </Link>
        <p className={styles.duration}>
          {/* {t('video.time', { time: '35 minut' })}{' '} */}
        </p>
        <Link href={articleUrl} className={styles.title}>
          {title}
        </Link>
        <div className={styles.author}>
          <AuthorIntro
            author={author}
            date={dateGmt}
            className={styles.author}
            thumbnailSize="small"
            variant='separate'
            color='orange'
          />
        </div>
      </div>
    </div>
  );
}

export default VideoCover;
